import { useTrans } from "@/translations";

import { Tooltip } from "react-tooltip";

import { twMerge } from "tailwind-merge";

import { Portal } from "./utils";

type Props = {
  id: string;
  link: string;
  isCollapsed?: boolean;
  tooltipText: string;
  icon: React.JSX.Element;
};

export const StyledLinkButton: React.FC<Props> = ({
  id,
  link,
  isCollapsed,
  tooltipText,
  icon,
}) => {
  const { t } = useTrans();

  return (
    <a
      href={link}
      className={twMerge(
        "hover:bg-buttery-lime flex h-8 items-center transition-colors",
        isCollapsed ? "w-full" : "pl-[25px]",
      )}
      target="_blank"
      id={id}
      data-tooltip-id={id}
      data-tooltip-delay-show={1000}
      rel="noreferrer"
    >
      <div
        className={twMerge(
          "relative flex items-center",
          isCollapsed && "w-full items-center justify-center",
        )}
      >
        {icon}
        {!isCollapsed && (
          <div className="ml-[11px] text-[13px]">{t(tooltipText)}</div>
        )}

        {isCollapsed && (
          <Portal>
            <Tooltip
              id={id}
              place="right"
              className="z-10000"
              content={t(tooltipText)}
              noArrow
              opacity={1}
            />
          </Portal>
        )}
      </div>
    </a>
  );
};
